export default __webpack_public_path__ + "static/media/Basic_Forge.1319c773.avif";